// PDFダウンロード画面
import React, { useState, useEffect, useCallback } from 'react';
import './List.css';
import '../App.css';
import {
  FormControl,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Snackbar,
  CircularProgress
} from '@material-ui/core';
import {
  makeStyles,
  withStyles,
  createStyles,
  Theme
} from '@material-ui/core/styles';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import FooterComponent from '../components/FooterComponent';
import { Redirect } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import {
  mainBlueColor,
  btnColor,
  isLoggedIn,
  userMenuId
} from '../GlobalState';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import LoadingComponent from '../components/LoadingComponent';
import { getEmployeeMasterList } from '../apicalls/employeeMaster';
import { getPdfList, getPdfDataToDownload } from '../apicalls/savePdf';
import { DatePickerInput } from '../components/atoms';
import { formatDatetime } from '../utils/common';
import { log } from '../utils';
import { BasicSelect } from '../components/parts/input/BasicSelect';
import { EMPLOYEE_TYPE } from '../const/Const';
import { getUserSelectOptions } from '../utils/processAndTaskFormUtils';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow);

export const PdfDownloadPage: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);

  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [clickedDocumentId, setClickedDocumentId] = useState<any>([]);

  const [userData, setUserData] = useState<any>([]);
  const [apiData, setApiData] = useState<any>([]);

  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );

  const [documentTypes] = useState<any>([
    { id: 1, name: '見積書' },
    { id: 2, name: '請求書' },
    { id: 3, name: '契約書' },
    { id: 4, name: '商品発注書' },
    { id: 5, name: '外注発注書' }
  ]);

  const [documentTypeId, setDocumentTypeId] = useState<number>(0);
  const [constructionName, setConstructionName] = useState<string>('');
  const [personInCharge, setPersonInCharge] = useState<number>(0);
  const [createdUser, setCreatedUser] = useState<number>(0);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [userMenu] = useRecoilState<any>(userMenuId);

  useEffect(() => {
    getListOfUsers();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getListOfPdfData(); //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    documentTypeId,
    constructionName,
    personInCharge,
    createdUser,
    startDate,
    endDate
  ]);

  const getListOfUsers = () => {
    getEmployeeMasterList('', 1, 0, EMPLOYEE_TYPE['INSIDE_EMPLOYEE']).then(
      data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setUserData(data.data);
            }
          }
        }
      }
    );
  };

  const getListOfPdfData = () => {
    getPdfList(
      documentTypeId,
      constructionName.trim(),
      personInCharge,
      createdUser,
      startDate ? formatDatetime(startDate, 'YYYY-MM-DD') : '',
      endDate ? formatDatetime(endDate, 'YYYY-MM-DD') : ''
    ).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setApiData(data);
            setLoading(false);
          }
        }
      }
      console.log(data);
    });
  };

  const downloadPdf = (
    id: number,
    documentTypeDetail: string,
    constructionName: string
  ) => {
    getPdfDataToDownload(id).then(data => {
      setClickedDocumentId([]);
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            const linkSource = `data:application/pdf;base64,${data.data}`;
            const downloadLink = document.createElement('a');
            const currentDatetime = formatDatetime(new Date(), 'YYYYMMDD');
            const fileName = `【${documentTypeDetail}】${constructionName}_${currentDatetime}.pdf`;
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
          }
        }
      }
    });
  };

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      formControl: {
        minWidth: 120,
        backgroundColor: '#FFFFFF'
      },
      formControl1: {
        minWidth: 120,
        height: 30,
        borderRadius: 5,
        borderWidth: 1,
        paddingLeft: 5
      },
      main: {
        minWidth: 700
      },
      table: {
        backgroundColor: `${mainColor} !important`,
        color: '#FFFFFF',
        fontSize: 16,
        fontWeight: 'bold'
      },
      input: {
        borderColor: '#CCCCCC',
        padding: 5,
        margin: 10
      },
      container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 15
      }
    })
  );

  const classes = useStyles();

  const [open, setOpen] = React.useState(false);

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const handleStartDateChange = (date: Date | null) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date: Date | null) => {
    setEndDate(date);
  };

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  if (userMenu == 'Storage') {
    return (
      <Redirect
        to={{
          pathname: '/constructions'
        }}
      />
    );
  }

  return (
    <div style={{ backgroundColor: '#F5F5F5' }}>
      <AppBarComponent patternName='pdf_download' />
      {loading ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent />
        </>
      ) : (
        <div
          style={{
            backgroundColor: '#F5F5F5',
            padding: 15,
            minHeight: window.innerHeight - 150
          }}
        >
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
              paddingTop: 10,
              paddingBottom: 5
            }}
          >
            <div
              style={{
                marginRight: 20,
                marginBottom: 15
              }}
              className='select-div'
            >
              <div>
                <FormControl className={classes.formControl}>
                  <BasicSelect
                    value={documentTypeId}
                    onChange={(e: any) => {
                      setDocumentTypeId(Number(e.target.value));
                    }}
                    style={{ paddingLeft: 5 }}
                    inputProps={{ 'aria-label': 'age' }}
                    disableUnderline
                  >
                    <option value={0}>帳票種類</option>
                    {documentTypes.map((i: any) => (
                      <option value={i.id}>{i.name}</option>
                    ))}
                  </BasicSelect>
                </FormControl>
              </div>
            </div>

            <input
              style={{
                backgroundColor: '#FFFFFF',
                marginRight: 20,
                marginBottom: 15
              }}
              className={classes.formControl1}
              placeholder='工事件名'
              maxLength={60}
              onChange={e => {
                setConstructionName(e.target.value);
              }}
            />

            <div
              style={{
                marginRight: 20,
                marginBottom: 15
              }}
              className='select-div'
            >
              <div>
                <FormControl>
                  <BasicSelect
                    value={personInCharge}
                    onChange={(e: any) => {
                      setPersonInCharge(e.target.value);
                    }}
                    style={{ paddingLeft: 5 }}
                    inputProps={{ 'aria-label': 'age' }}
                    disableUnderline
                  >
                    <option value={0}>担当者</option>
                    {getUserSelectOptions(userData)}
                  </BasicSelect>
                </FormControl>
              </div>
            </div>

            <div
              style={{
                marginRight: 20,
                marginBottom: 15
              }}
              className='select-div'
            >
              <div>
                <FormControl>
                  <BasicSelect
                    value={createdUser}
                    onChange={(e: any) => {
                      setCreatedUser(e.target.value);
                    }}
                    style={{ paddingLeft: 5 }}
                    inputProps={{ 'aria-label': 'age' }}
                    disableUnderline
                  >
                    <option value={0}>作成者</option>
                    {getUserSelectOptions(userData)}
                  </BasicSelect>
                </FormControl>
              </div>
            </div>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginRight: 20,
                marginBottom: 15,
                flexWrap: 'wrap'
              }}
            >
              <span style={{ marginRight: 5 }}>作成日:</span>
              <div
                className='select-div'
                style={{
                  backgroundColor: '#FFFFFF',
                  height: 27,
                  paddingBottom: 5,
                  paddingLeft: 5,
                  marginRight: 10
                }}
              >
                <DatePickerInput
                  date={startDate}
                  onChange={handleStartDateChange}
                  id='date-picker-inline'
                  emptyLabel='開始日'
                  maxDate={endDate ? endDate : undefined}
                />
              </div>
              <span style={{ marginRight: 10, fontSize: 20 }}>~</span>
              <div
                className='select-div'
                style={{
                  backgroundColor: '#FFFFFF',
                  height: 27,
                  paddingBottom: 5,
                  paddingLeft: 5
                }}
              >
                <DatePickerInput
                  date={endDate}
                  onChange={handleEndDateChange}
                  id='date-picker-inline'
                  emptyLabel='終了日'
                  minDate={startDate ? startDate : undefined}
                />
              </div>
            </div>
          </div>

          <div
            style={{ padding: 15, backgroundColor: '#FFFFFF', borderRadius: 5 }}
          >
            <TableContainer component={Paper}>
              <Table className={classes.main} aria-label='customized table'>
                <TableHead>
                  <TableRow>
                    <StyledTableCell className={classes.table} align='center'>
                      帳票番号
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      帳票種類
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      工事件名
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      担当者
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      作成者
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      作成日
                    </StyledTableCell>
                    <StyledTableCell
                      className={classes.table}
                      align='center'
                    ></StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {apiData.map((row: any, index: number) => (
                    <StyledTableRow key={row.id}>
                      <StyledTableCell style={{ minWidth: 80 }} align='center'>
                        {row.code}
                      </StyledTableCell>
                      <StyledTableCell style={{ minWidth: 100 }} align='center'>
                        {row.document_type_detail}
                      </StyledTableCell>
                      <StyledTableCell style={{ minWidth: 100 }} align='center'>
                        {row.construct_name}
                      </StyledTableCell>
                      <StyledTableCell style={{ minWidth: 130 }} align='center'>
                        {row.assignee_name}
                      </StyledTableCell>
                      <StyledTableCell style={{ minWidth: 100 }} align='center'>
                        {row.created_user_name}
                      </StyledTableCell>
                      <StyledTableCell style={{ minWidth: 120 }} align='center'>
                        {row.created_at_str}
                      </StyledTableCell>
                      <StyledTableCell style={{ minWidth: 150 }} align='center'>
                        <Button
                          style={{ backgroundColor: buttonColor }}
                          variant='contained'
                          color='primary'
                          onClick={() => {
                            setClickedDocumentId([
                              ...clickedDocumentId,
                              row.document_id
                            ]);
                            log.info(
                              `download: ${row.document_type_detail} from pdfdownload`
                            );
                            downloadPdf(
                              row.document_id,
                              row.document_type_detail,
                              row.construct_name
                            );
                          }}
                        >
                          {clickedDocumentId.includes(row.document_id) ? (
                            <CircularProgress
                              style={{
                                color: '#FFFFFF',
                                height: 20,
                                width: 20
                              }}
                            />
                          ) : (
                            <>PDFダウンロード</>
                          )}
                        </Button>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
              {!loading && apiData.length === 0 && (
                <div className={classes.container}>データがありません</div>
              )}
            </TableContainer>
          </div>
        </div>
      )}
      <FooterComponent />
    </div>
  );
};
